import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { VehicleFeatureModel } from './../models/Booking/VehicleReservationCaseResult';
import { Vehicle } from 'src/app/models/Vehicle';
import { VehicleImagesModel } from './../models/Vehicle/VehicleImagesModel';
import { ReservationSettingModel } from './../models/Booking/ReservationSettingModel';
import { ApiControllerActionEnum } from './../models/enums/ApiControllerActionEnum';
import { LanguageModel } from './../models/LanguageModel';

import * as moment from 'moment';
import { position } from './../models/position';
import { environment } from './../../environments/environment';
import { Branch } from './../models/Branch';

import { Injectable } from '@angular/core';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { VehicleReservationSearchLevlZeroModel, VehicleReservationSearchResult } from './../models/VehicleReservationSearchResult';
import { VehicleReservationSearchAgencyResult, VehicleReservationSearchAgencyTemplate } from './../models/VehicleReservationSearchAgencyResult';
import { VehicleReservationSearchParm } from '../models/VehicleReservationSearchParm';
import { DropUpLocaionModel } from '../models/DropUpLocaionModel';
import { ResourceService } from './resource.service';
import { CurrencyModel } from '../models/CurrencyModel';
import { LstPolicyReservationCaseModel } from '../models/VehicleReservationCaseDetailsModel';
import { GetCustomerFavouriteReservationsModel } from 'src/app/models/CustomerFavourite/GetCustomerFavouriteReservationsModel'
import { GetUserNotificationsResult } from 'src/app/models/Notifications/GetUserNotificationsResult'
import { AdvanceSearchDataModel, SelectListItems } from 'src/app/models/AdvanceSearchDataModel'
import { RentalServiceDeliveryChannel } from '../models/enums/Payments/PaymnetsEnum';
import { VehicleSearchTypeEnum } from '../models/enums/VehicleSearchTypeEnum';
import { CampaignsReservationCaseModel, MembershipModel } from '../models/VehicleReservationCaseDetailsModel';
import { NotificationTemplateType } from '../models/enums/Notification/NotificationStatusEnum';


@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private _branches = new BehaviorSubject<Branch[]>(null);
  //private dataStore: { branches: Branch[] } = { branches: [] };
  readonly branches = this._branches.asObservable();

  private _vehicles = new BehaviorSubject<Vehicle[]>([]);
  readonly vehicles = this._vehicles.asObservable();

  private _currentPos = new BehaviorSubject<position>({ lat: 0, lng: 0 });

  readonly currentPos = this._currentPos.asObservable();

  private _currentOpenInfoWindow = new BehaviorSubject<string>('');
  readonly currentOpenInfoWindow = this._currentOpenInfoWindow.asObservable();


  private _searchModel = new BehaviorSubject<VehicleReservationSearchParm>(null);
  readonly searchModel = this._searchModel.asObservable();



  private _vehicleReservationSearchAgency = new BehaviorSubject<VehicleReservationSearchAgencyTemplate>(null);
  readonly vehicleReservationSearchAgency = this._vehicleReservationSearchAgency.asObservable();

  private _reservationSettingModel = new BehaviorSubject<ReservationSettingModel>(null);
  readonly reservationSettingModel = this._reservationSettingModel.asObservable();


  private _selectedDropOffLocation = new BehaviorSubject<DropUpLocaionModel>(null);
  readonly selectedDropOffLocation = this._selectedDropOffLocation.asObservable();

  private dataStore: { selectedDropOffLocation: DropUpLocaionModel, reservationSettingModel: ReservationSettingModel, vehicleReservationSearchAgency: VehicleReservationSearchAgencyTemplate, branches: Branch[], vehicles: Vehicle[], currentPos: position, currentOpenInfoWindow: string, searchModel: VehicleReservationSearchParm } = { reservationSettingModel: null, vehicleReservationSearchAgency: null, branches: null, vehicles: [], currentPos: { lat: 0, lng: 0 }, currentOpenInfoWindow: '', searchModel: null, selectedDropOffLocation: null };

  readonly pageSize = 10; //Global Setting Variable
  readonly notificationsPageSize = 8;
  private selectedLang: LanguageModel;
  private selectedCurrency: CurrencyModel;
  returnLocations: DropUpLocaionModel[];

  advanceSearchFilterForm;

  levelZeroTotalCount: number = 0;

  constructor(private http: HttpClient, resourceService: ResourceService, private _dateFormatPipe: DateFormatPipe) {

    resourceService.selectedLanguage.subscribe(res => this.selectedLang = res);
    resourceService.selectedCurrency.subscribe(res => this.selectedCurrency = res);
    let _chachedSearch = this.getCachedSearchModel();
    if (_chachedSearch != null) {
      this.updateSearchModel(_chachedSearch);
    }
  }


  //#region  selectedDropOffLocation

  updateSelectedDropOffLocation(model) {
    this.dataStore.selectedDropOffLocation = model;
    this._selectedDropOffLocation.next(Object.assign({}, this.dataStore).selectedDropOffLocation);
  }
  //#endregion
  //#region  SearchByLocation (Branch)

  //HTTP Post to '\VehicleReservationSearch'
  //Get List Of Branches
  //it supported paging.
  VehicleReservationSearch(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    model["Lang"] = this.selectedLang.isoCode2;
    model.CurrencyID = this.selectedCurrency.currencyID;
    model.TimeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["Lang"] = this.selectedLang.isoCode2;
    return this.http.post<VehicleReservationSearchLevlZeroModel>(ApiControllerActionEnum.VehicleReservationSearch, JSON.stringify(model));
  }

  update(branch: Branch) {

    if (this.dataStore.branches != null) {
      this.dataStore.branches.forEach((t, i) => {
        if (t.id === branch.id) {
          this.dataStore.branches[i] = branch;
        }
      });

      this._branches.next(Object.assign({}, this.dataStore).branches);
    }


  }
  //Load a new Branch List , remove the previous list if exist
  loadBranchList(listOfBranchs: Branch[]) {

    this.dataStore.branches = listOfBranchs;
    this._branches.next(Object.assign({}, this.dataStore).branches);
  }
  //Update the Branch List by adding new items to the List.
  updateBranchList(listOfBranchs: Branch[]) {

    this.dataStore.branches = this.dataStore.branches.concat(listOfBranchs);
    this._branches.next(Object.assign({}, this.dataStore).branches);
  }
  setSelectedBranch(branch: Branch) {
    //Set only one branch - (the branch that the user select)
    this.dataStore.branches = [branch];
    this._branches.next(Object.assign({}, this.dataStore).branches);
  }

  //Convert list of VehicleReservationSearchResult to List of Branch model
  vehicleReservationResultToBranch(res) {
    let branchList: Branch[] = [];
    res.forEach((element, index) => {

      let iconUrl1 = this.svgToUrlImage(element.rentalUnitPrice, 2);
      let iconUrl2 = this.svgToUrlImage(element.rentalUnitPrice, 1);
      var branchModel = new Branch(element, iconUrl1, iconUrl2, index);
      branchList.push(branchModel);
    });
    return branchList;

  }



  //#endregion


  getCurrency() {
    return this.selectedCurrency.code;
  };


  loadAll() {

    //This Will be http get for now get static data
    //var data = this.getBranches();
    var data = []; //Temppp
    data.forEach(element => {

      element.iconUrl1 = this.svgToUrlImage(element.price, 2);
      element.iconUrl2 = this.svgToUrlImage(element.price, 1);
      element.icon = element.iconUrl1; //Default is the Icon1
    });
    this.dataStore.branches = data;
    this._branches.next(Object.assign({}, this.dataStore).branches);

  }


  loadByPage(page, pageSize) {

    /* var list=this.getBranches();
    var oldContentSize=page-1<0?0:(page-1)*pageSize;
    if(oldContentSize>=list.length){
      return;
    }
    var data=list.slice(oldContentSize,(page*pageSize));
    data.forEach(element => {

      element.iconUrl1= this.svgToUrlImage(element.price,2);
      element.iconUrl2= this.svgToUrlImage(element.price,1);
      element.icon=element.iconUrl1; //Default is the Icon1
      });
    this.dataStore.branches = this.dataStore.branches.concat(data);
    this._branches.next(Object.assign({}, this.dataStore).branches); */
  }





  //#region Shared

  updateSelectedLocation(pos: position) {
    this.dataStore.currentPos = pos;
    this._currentPos.next(Object.assign({}, this.dataStore).currentPos);
  }



  //Set the Branch ID of the current Opened Google Info Window (map popup)
  openInfoWindow(id) {

    this.dataStore.currentOpenInfoWindow = id;
    this._currentOpenInfoWindow.next(Object.assign({}, this.dataStore).currentOpenInfoWindow);

  }


  //#endregion



  //#region  Helpers

  //Get Google address object From {Lat,Lng} points
  geocode(lat, lng) {

    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.googleKey}`);
  }

  private imageSvgString(value, type) {
    value = parseFloat(value).toFixed(3);
    var svgString = ''
    switch (type) {
      case 1:
        svgString = `<svg  width="100" style="z-index: 9999999999 !important;position: relative !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.89 25.95"><defs><style>.cls-1{fill:#38a3dc;font-size:6px;}.cls-2{font-size:6px;font-family:Montserrat-Light, Montserrat; position:absolute;}.cls-2,.cls-3{fill:#fff;font-size:6px;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polyline class="cls-1" points="8.48 10.27 0 25.95 21.88 14.7"/><path class="cls-1" d="M49.89,15.77H8.48V6.94A6.94,6.94,0,0,1,15.42,0H49.89V15.77"/><text style="font-size:5.8px;font-family:Montserrat-Light, Montserrat;"  class="cls-2" transform="translate(23.0 10.0)">${value}</text><path class="cls-3" d="M18,7.6v.6a.5.5,0,0,0,.3.5l.2.2h.1v.7a2.2,2.2,0,0,1-.9.7,3.7,3.7,0,0,1-1.5.3,3.7,3.7,0,0,1-2.5-1,3.3,3.3,0,0,1-1-2.5,3.3,3.3,0,0,1,1-2.4,3.3,3.3,0,0,1,2.5-1l1.2.2.6.3a.7.7,0,0,0,.9-.2A.6.6,0,0,0,18.7,3l-.6-.3a4.1,4.1,0,0,0-1.9-.4,4.8,4.8,0,0,0-3.5,1.4,4.9,4.9,0,0,0-1.5,3.5,4.9,4.9,0,0,0,1.5,3.6A6.2,6.2,0,0,0,14.6,12l-1,1.8,3.2-1.6,1.8-.5a5.6,5.6,0,0,0,1.6-1.4V7.6H18"/></g></g></svg>`
        return svgString;
      case 2:
        svgString = `<svg   width="100"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.89 25.95"><defs><style>.cls-1{fill:#666;font-size:6px;}.cls-2{font-size:6px;font-family:Montserrat-Light, Montserrat; position:absolute;}.cls-2,.cls-3{fill:#fff;font-size:6px;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polyline class="cls-1" points="8.48 10.27 0 25.95 21.88 14.7"/><path class="cls-1" d="M49.89,15.77H8.48V6.94A6.94,6.94,0,0,1,15.42,0H49.89V15.77"/><text style="font-size:5.8px;font-family:Montserrat-Light, Montserrat;"  class="cls-2" transform="translate(23.0 10.0)">${value}</text><path class="cls-3" d="M18,7.6v.6a.5.5,0,0,0,.3.5l.2.2h.1v.7a2.2,2.2,0,0,1-.9.7,3.7,3.7,0,0,1-1.5.3,3.7,3.7,0,0,1-2.5-1,3.3,3.3,0,0,1-1-2.5,3.3,3.3,0,0,1,1-2.4,3.3,3.3,0,0,1,2.5-1l1.2.2.6.3a.7.7,0,0,0,.9-.2A.6.6,0,0,0,18.7,3l-.6-.3a4.1,4.1,0,0,0-1.9-.4,4.8,4.8,0,0,0-3.5,1.4,4.9,4.9,0,0,0-1.5,3.5,4.9,4.9,0,0,0,1.5,3.6A6.2,6.2,0,0,0,14.6,12l-1,1.8,3.2-1.6,1.8-.5a5.6,5.6,0,0,0,1.6-1.4V7.6H18"/></g></g></svg>`
        return svgString;
      default:
        return svgString;

    }

  }

  svgToUrlImage(value, type) {
    /* var s=new XMLSerializer().serializeToString(svgString);

    var encodedData = window.btoa(s);
    */

    let svgString = this.imageSvgString(value, type);
    var DOMURL = self.URL || self.webkitURL || self;
    var img = new Image();

    var svg = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    let objectURL = URL.createObjectURL(svg);
    /*  img.onload = function(){
       URL.revokeObjectURL(objectURL);
   };
     img.src=objectURL; */
    //URL.revokeObjectURL(objectURL);
    return objectURL;
  }


  //#endregion





  //#region Vehicle


  //HTTP Post to '\VehicleReservationSearchByAgency'
  //Get List Of Vehicles
  //the API will return Vehicles categorized  By Class or Vehicle or MakeModelYear based on the setting
  VehicleReservationSearchByAgency(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    this.advanceSearchFilterForm = null;
    model["Lang"] = this.selectedLang.isoCode2;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model.TimeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http.post<VehicleReservationSearchAgencyTemplate>(ApiControllerActionEnum.VehicleReservationSearchByAgency, JSON.stringify(model));
  }

  //#region  Advance Search

  //HTTP Post to '\VehicleReservationAdvanceSearch'
  VehicleReservationAdvanceSearch(model: any) {
    model["Lang"] = this.selectedLang.isoCode2;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["TimeZoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http.post<VehicleReservationSearchAgencyTemplate>(ApiControllerActionEnum.VehicleReservationAdvanceSearch, JSON.stringify(model));
  }

  getAdvanceSearchData() {
    return this.http.get<AdvanceSearchDataModel>(ApiControllerActionEnum.GetAdvanceSearchData + `?lang=${this.selectedLang.isoCode2}`);
  }

  getModelsByMakeID(makeID) {
    return this.http.get<Array<SelectListItems>>(ApiControllerActionEnum.GetModelsByMakeID + `?makeID=${makeID}&lang=${this.selectedLang.isoCode2}`);
  }

  //#endregion

  loadVehicleList(list: Vehicle[]) {

    this.dataStore.vehicles = list;
    this._vehicles.next(Object.assign({}, this.dataStore).vehicles);

  }



  //#endregion



  //#region  SearchSection

  updateSearchModel(model) {

    this.dataStore.searchModel = model;
    this._searchModel.next(Object.assign({}, this.dataStore).searchModel);
    this.cachedSearchModel(model);

  }
  cachedSearchModel(model) {
    localStorage.setItem('searchModel', JSON.stringify(model));
  }
  getCachedSearchModel() {
    return JSON.parse(localStorage.getItem('searchModel'));
  }

  getDropUpLocationsByAgencyID(agencyID, lang, isSearchAvailability, classID?, makeID?, modelID?, year?, vehicleID?) {

    let params = `?currencyID=${this.selectedCurrency.currencyID}&agencyID=${agencyID}&lang=${this.selectedLang.isoCode2}&isSearchAvailability=${isSearchAvailability}`

    params += '&rentalServiceDeliveryChannelID=' + RentalServiceDeliveryChannel.Online;

    if (classID != null) {
      params += `&classID=${classID}`;
    }
    if (makeID != null) {
      params += `&makeID=${makeID}`;
    }
    if (modelID != null) {
      params += `&modelID=${modelID}`;
    }
    if (year != null) {
      params += `&year=${year}`;
    }
    if (vehicleID != null) {
      params += `&vehicleID=${vehicleID}`;
    }


    return this.http.post<Array<DropUpLocaionModel>>(ApiControllerActionEnum.VehicleReservationGetReturnLocations + params, {});
  }
  getDropUpLocations(lang) {
    return this.http.post<Array<DropUpLocaionModel>>(ApiControllerActionEnum.VehicleReservationGetReturnLocations + `?currencyID=${this.selectedCurrency.currencyID}&lang=${this.selectedLang.isoCode2}&rentalServiceDeliveryChannelID=${RentalServiceDeliveryChannel.Online}`, {});
  }

  getFirstValidSartDate(date, gracePeriod) {
    date.setHours(date.getHours() + gracePeriod); //Set the time to the next hour

    return date;
  }

  //To get the First available time to search a car on (Not to book a car before the currentTime+Grace period)
  getFirstValidSartTime(date, gracePeriod) {
    date.setHours(date.getHours() + gracePeriod); //Set the time to the next hour
    let last15MinDividable = this.getLast15MinDividable(date.getMinutes());
    date.setMinutes(last15MinDividable); // Resets also seconds and milliseconds
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + '' + ampm;
    return strTime;
  }
  /*   getFirstValidDropOffTime(dateOriginal,gracePeriod) {

      let date=new Date ( dateOriginal );
      let last15MinDividable=this.getLast15MinDividable(dateOriginal.getMinutes());
      date.setMinutes ( last15MinDividable + 15 );

      date.setHours(date.getHours() + gracePeriod); //Set the time to the next hour
      //date.setMinutes(0, 0, 0); // Resets also seconds and milliseconds
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      let minutesSt = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutesSt + '' + ampm;
      return strTime;
    } */
  getLast15MinDividable(minutes) {
    for (let index = minutes; index >= 0; index++) {
      if (index % 15 == 0) {
        return index;
      }
    }
    return 0;
  }


  //Validate 00:00am|pm time with the min time , because the user may write a custom time
  //The 0:00am|pm is validated by pattern validatior in the form
  validateTime(startTime, minTime) {

    //Get PickUpTime and MinValidTime as String
    var _pickUpTime = startTime + "";
    var _minTime = minTime + "";

    //TO handle am|AM compination
    _pickUpTime = _pickUpTime.toLocaleLowerCase();
    _minTime = _minTime.toLocaleLowerCase();

    //This to add 0 at the begging if the first section contains only one
    // E.g: 9:00am will convert to 09:00am
    let firstSection = _pickUpTime.split(':')[0]
    if (firstSection != null && firstSection.length < 2) {
      _pickUpTime = '0' + _pickUpTime;
    }

    firstSection = _minTime.split(':')[0]
    if (firstSection != null && firstSection.length < 2) {
      _minTime = '0' + _minTime;
    }

    //Replace the am with a minus (-) to make the comparison
    if (_pickUpTime.includes('am')) {
      _pickUpTime = '-' + _pickUpTime.replace('am', '');

    }
    else {
      _pickUpTime = _pickUpTime.replace('pm', '');
    }

    //Replace the am with a minus (-) to make the comparison
    if (_minTime.includes('am')) {
      _minTime = '-' + _minTime.replace('am', '');

    }
    else {
      _minTime = _minTime.replace('pm', '');
    }

    //Compare the two time
    if (_pickUpTime < _minTime)
      return false;

    return true;
  }

  /**
  * compare Two Time and  Returns 0 if equal, 1 if time1 greater, -1 if time2 greater.
  *
  *
  * @param pickUpTime - The time1
  * @param dropOffTime - The time2
  * @returns 0 or 1 or -1 based on compare result
  *
  */
  compareTwoTime(pickUpDate: Date, pickUpTime: string, dropOffDate: Date, dropOffTime: string) {

    return this.compareTwoTimeWithMomentJS(pickUpDate, pickUpTime, dropOffDate, dropOffTime);

    // //Get PickUpTime and MinValidTime as String
    // var _pickUpTime = pickUpTime + "";
    // var _dropOffTime = dropOffTime + "";

    // //TO handle am|AM compination
    // _pickUpTime = _pickUpTime.toLocaleLowerCase();
    // _dropOffTime = _dropOffTime.toLocaleLowerCase();

    // //This to add 0 at the begging if the first section contains only one
    // // E.g: 9:00am will convert to 09:00am
    // let firstSection = _pickUpTime.split(':')[0]
    // if (firstSection != null && firstSection.length < 2) {
    //   _pickUpTime = '0' + _pickUpTime;
    // }

    // firstSection = _dropOffTime.split(':')[0]
    // if (firstSection != null && firstSection.length < 2) {
    //   _dropOffTime = '0' + _dropOffTime;
    // }

    // //Replace the am with a minus (-) to make the comparison
    // if (_pickUpTime.includes('am')) {
    //   _pickUpTime = '-' + _pickUpTime.replace('am', '');

    // }
    // else {
    //   _pickUpTime = _pickUpTime.replace('pm', '');
    // }

    // //Replace the am with a minus (-) to make the comparison
    // if (_dropOffTime.includes('am')) {
    //   _dropOffTime = '-' + _dropOffTime.replace('am', '');

    // }
    // else {
    //   _dropOffTime = _dropOffTime.replace('pm', '');
    // }

    // let pickUpSplit = _pickUpTime.split(":");
    // let pickUpHours = Number(pickUpSplit[0]);
    // let pickUpMins = Number(pickUpSplit[1]);

    // let dropOffSplit = _dropOffTime.split(":");
    // let dropOffHours = Number(dropOffSplit[0]);
    // let dropOffMins = Number(dropOffSplit[1]);


    // //Compare the two time
    // if (pickUpHours == dropOffHours) {
    //   if (pickUpMins == dropOffMins) {
    //     return 0;
    //   }
    //   else if (pickUpMins < dropOffMins) {
    //     return 1;
    //   }
    //   else {
    //     return -1;
    //   }

    // }
    // else if (pickUpHours < dropOffHours) {
    //   return 1;
    // }
    // //If pickup greater
    // else {
    //   return -1;
    // }



  }

  compareTwoTimeWithMomentJS(pickUpDate: Date, pickUpTime: string, dropOffDate: Date, dropOffTime: string): number {


    let pickupDateString = this._dateFormatPipe.transform(pickUpDate);
    let dropOffDateString = this._dateFormatPipe.transform(dropOffDate);

    //let t1 = moment(this.convertTime12to24(pickUpTime), ['H:m'], true); // Wed Dec 30 2015 07:00:00 GMT-0600 (CST)
    //let t2 = moment('5:00 PM', ['h:m a', 'h:m a'], true);

    //var mj_pickUpTime1 = moment(pickupDateString, 'DD/MM/YYYY', true);
    //var mj_dropOffTime2 = moment(dropOffDateString, 'DD/MM/YYYY', true);

    let pickUpTime24 = this.convertTime12to24(pickUpTime);
    let dropOffTime24 = this.convertTime12to24(dropOffTime);

    var mj_pickUpTime = moment(pickupDateString + 'T' + pickUpTime24, 'DD/MM/YYYYTH:m', true);
    var mj_dropOffTime = moment(dropOffDateString + 'T' + dropOffTime24, 'DD/MM/YYYYTH:m', true);


    if (mj_pickUpTime.isSame(mj_dropOffTime)) {
      return 0;
    }
    else if (mj_pickUpTime.isBefore(mj_dropOffTime)) {
      return 1;
    }
    else {
      return -1;
    }

  }

  convertTime12to24 = (time12h: string) => {
    time12h = time12h.replace('am', ' am');
    time12h = time12h.replace('pm', ' pm');



    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }

    let hourNumber = parseInt(hours);
    if (modifier === 'pm' || modifier === 'PM') {
      hourNumber = parseInt(hours, 10) + 12;
    }

    return `${hourNumber}:${minutes}`;
  }

  /**
* compare PickUp datetime and dropOffTime and return false if there is any validation erros
*
*
* @param pickUpDate - PickUp Date : Date
* @param pickUpTime - Pick Time : string
* @param dropOffDate - DropOff Date : Date
* @param dropOffTime - DroppOff Time : string
* @returns  true if no validation errors | false if there validation errors
*
*/
  validateDropOffVSPickUp(pickUpDate: Date, pickUpTime: string, dropOffDate: Date, dropOffTime: string): boolean {

    let isValid = true;

    pickUpDate.setHours(0,0,0,0);
    dropOffDate.setHours(0,0,0,0);

    if (pickUpDate > dropOffDate) return false;

    if (dropOffDate.getDate() == pickUpDate.getDate()) {

      //If dropOff equal or greaer than pickup
      if (this.compareTwoTime(pickUpDate, pickUpTime, dropOffDate, dropOffTime) <= 0) {
        isValid = false;
      }
    }
    return isValid;
  }
  //#endregion


  updateVehicleReservationSearchAgency(model) {

    this.dataStore.vehicleReservationSearchAgency = model;
    this._vehicleReservationSearchAgency.next(Object.assign({}, this.dataStore).vehicleReservationSearchAgency);
  }

  getVehicleReservationPolicy(model) {
    return this.http.post<Array<LstPolicyReservationCaseModel>>(ApiControllerActionEnum.GetVehicleReservationPolicy, JSON.stringify(model));
  }

  //#region Favorite

  addCustomerFavouriteReservation(model) {

    return this.http.post(ApiControllerActionEnum.AddCustomerFavouriteReservation, JSON.stringify(model));
  }
  getCustomerFavouriteReservations(customerID) {
    let timeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;


    return this.http.post<Array<GetCustomerFavouriteReservationsModel>>(ApiControllerActionEnum.GetCustomerFavouriteReservations
      + `?customerID=${customerID}&currentLanguage=${this.selectedLang.isoCode2}&currencyID=${this.selectedCurrency.currencyID}&timeZone=${timeZoneCode}&rentalServiceDeliveryChannel=${RentalServiceDeliveryChannel.Online}`, {});
  }
  deleteCustomerFavouriteReservation(customerFavouriteReservationID, customerName) {
    return this.http.post(ApiControllerActionEnum.DeleteCustomerFavouriteReservation
      + `?customerFavouriteReservationID=${customerFavouriteReservationID}&modifiedBy=${customerName}`, {});
  }
  //#endregion

  //#region  Country Code

  getCountryCodeFromIP() {
    //Get Country code from ip-api.com
    return this.http.get('http://ip-api.com/json');
  }
  //#endregion

  //#region  User Notifications

  getUserNotificationsResult(userID, pageNumber, pageSize) {
    return this.http.get<GetUserNotificationsResult>(ApiControllerActionEnum.GetUserNotificationsResult
      + `?userId=${userID}&pageNumber=${pageNumber}&pageSize=${pageSize}&notificationTypeID=${NotificationTemplateType.SignalR}`);
  }

  updateNotificationStatus(notificationIDs, statusID) {
    return this.http.get(ApiControllerActionEnum.UpdateNotificationStatus + `?id=${notificationIDs}&statusId=${statusID}`);
  }

  deleteAllNotifications(userID) {
    return this.http.get(ApiControllerActionEnum.DeleteAllNotifications + `?userId=${userID}`);
  }

  //#endregion


  //#endregion Booking Search Setting

  reservationSettings() {
    return this.http.get<ReservationSettingModel>(ApiControllerActionEnum.ReservationSettings);
  }
  updateReservationSettingModel(model) {
    this.dataStore.reservationSettingModel = model;
    this._reservationSettingModel.next(Object.assign({}, this.dataStore).reservationSettingModel);
  }
  //#endregion

  //#region

  getVehicleGalleryByVehicleID(vehicleID) {
    return this.http.get<Array<VehicleImagesModel>>(ApiControllerActionEnum.GetVehicleGalleryByVehicleID + `?vehicleID=${vehicleID}`);
  }

  //#endregion
  campaignID?: string;
  membershipID?: string;
  customerFavouriteReservationsToVehicle(model: GetCustomerFavouriteReservationsModel, type): Vehicle {

    let vehicle: Vehicle = {

    };

    vehicle.shownPricesIncludeTax = model.shownPricesIncludeTax;
    vehicle.includeMandatoryCharges = model.includeMandatoryCharges;

    //vehicle.totalOutsideWorkingHoursCharge = model.totalOutsideWorkingHoursCharge;
    //vehicle.agencyName = model.agencyName;
    vehicle.agencyID = model.agencyID;
    vehicle.vehicleLocation = model.locationName;
    vehicle.evaluationSummary = model.evaluationSummary;
    vehicle.makeModelYearName = model["makeModelYearName"];
    //vehicle.lstPolicyReservationCaseModel = model.lstPolicyReservationCaseModel;


    if (model.isAvailable != null) {
      vehicle.isAvailable = model.isAvailable;
    }


    vehicle.campaignsReservationCaseModel = model.campaignsReservationCaseModel;
    vehicle.membershipModel2 = model.membershipModel2;

    vehicle.customerFavouriteReservationID = model.customerFavouriteReservationID;
    vehicle.searchAvailableVehicleFilterType = type;
    vehicle.isFavorite = model.customerFavouriteReservationID != null ? true : false;
    let _feature: VehicleFeatureModel;
    _feature = model.featuresModel;
    vehicle.pricingRuleID = model.pricingRuleID;
    //added for favourits total rentals
    vehicle.vehicleRentalNumber = model.totalRentals;
    //vehicle.vehicleName = model.makeModelYear;
    vehicle.vehicleClass = model.vehicleClassName;
    //this.vehicleImage = 'assets/img/car.png';
    //vehicle.hasAirConditions = model.hasAirConditions;
    vehicle.vehicleLocation = model.locationName;
    vehicle.vehicleTotalReviews = 0;
    vehicle.plateNumber = model.plateNumber;
    vehicle.vehiclePrice = model.rentalUnitPrice;
    //vehicle.periodInDays = model.durationInDays;
    vehicle.durationUnitName = model.durationUnitName != null ? model.durationUnitName.replace('-', ' ') : '';
    vehicle.makeID = model.makeID;
    vehicle.classID = model.classID;
    vehicle.modelID = model.modelID;
    vehicle.year = model.year;
    vehicle.vehicleID = model.vehicleID;
    vehicle.contractTypeID = 1;
    vehicle.rateTypeID = model.rateTypeID;

    vehicle.campaignID = model.campaignID;
    vehicle.membershipID = model.membershipID;
    vehicle.membershipModel = model.membershipModel;

    //this.membershipName = model.membershipName;


    //For My Favorites

    vehicle.pickupLocationID = model['pickupLocationID']
    vehicle.dropOffLocationID = model['dropOffLocationID']
    vehicle.dropOffLocationTypeID = model['dropOffLocationTypeID']
    vehicle.fromAgencyName = model['fromAgencyName'];
    vehicle.toAgencyName = model['toAgencyName'];
    //end for my Favorite


    //Class Search
    if (type == VehicleSearchTypeEnum.classSearch) {

      //this.vehicleColors = JSON.parse(model.vehicleColors + "");

      //this.vehicleColors=model.vehicleColors;
      vehicle.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      vehicle.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      vehicle.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName + '');
      vehicle.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName + '');
      vehicle.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      vehicle.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);

    }
    else if (type == VehicleSearchTypeEnum.MakeModelYearSearch) {

      vehicle.vehicleName = model.makeModelYearName;
      vehicle.vehicleColors = JSON.parse(model.vehicleColors + "");

      vehicle.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      vehicle.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      vehicle.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName + '');
      vehicle.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName + '');
      vehicle.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      vehicle.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);

    }
    else {

      if (model.extericColor != null) {
        vehicle.vehicleColors = [model.extericColor];
      }
      else {
        vehicle.vehicleColors = JSON.parse(model.vehicleColors);
      }

      if (_feature != null) {
        vehicle.vehicleGearType = _feature.gearBox != null ? _feature.gearBox[0].gearBoxName : '';
        vehicle.vehiclePetrolType = _feature.fuel != null ? _feature.fuel[0].fuelName : '';
        vehicle.vehiclePassengersNumber = _feature.passengers != null ? _feature.passengers[0].passengersName + '' : '';
        vehicle.vehicleDoorsNumber = _feature.numberOfDoors != null ? _feature.numberOfDoors[0].numberOfDoorsName + '' : '';
        //this.vehicleClass=_feature.vehicleType[0]!=null?_feature.vehicleType[0].vehicleTypeName:'';
        vehicle.vehicleStorage = _feature.storgeCapacity != null ? _feature.storgeCapacity[0].storgeCapacityName : '';
      }

      vehicle.vehicleOdometer = model.odometerView;
      //For the demo take only one word
      /*         this.vehicleColors=[model.extericColor];
              this.vehicleGearType=_feature.GearBox[0].GearBoxName.split(' ')[0];;
              this.vehiclePetrolType=_feature.Fuel[0].FuelName.split(' ')[0];;
              this.vehiclePassengersNumber=_feature.Passengers[0].PassengersName;
              this.vehicleDoorsNumber=_feature.NumberOfDoors[0].NumberOfDoorsName;
              this.vehicleClass=_feature.VehicleType[0].VehicleTypeName.split(' ')[0];
              this.vehicleStorage=_feature.StorgeCapacity[0].StorgeCapacityName.split(' ')[0];
              this.vehicleOdometer=model.odometer; */
    }


    switch (type) {
      case VehicleSearchTypeEnum.classSearch:
        vehicle.classSearch = true;
        break
      case VehicleSearchTypeEnum.MakeModelYearSearch:
        vehicle.makeModelYearSearch = true;
        break
      case VehicleSearchTypeEnum.vehicleSearch:
        vehicle.vehicleSearch = true;
        break
    }


    return vehicle;
  }

}







